import { computed, toValue } from 'vue';
import { useQuery, type UseQueryReturnType } from '@tanstack/vue-query';
import type {
  OrganizationBranding,
  OrganizationBrandingApiResponse,
  UseOrganizationBrandingsParams
} from '@/types/deepadmin/Branding';
import { useApi } from '@/composables/useApi.ts';

export function useOrganizationBrandingQuery(
  params: UseOrganizationBrandingsParams
): UseQueryReturnType<OrganizationBranding, Error> {
  const { deepSignAPI } = useApi();
  const queryKey = computed(
    () => ['organization', toValue(params.documentId), 'brandings'] as const
  );

  const query = useQuery<OrganizationBranding | null, Error>({
    queryKey,
    enabled: params.enabled,
    queryFn: async ({ signal }) => {
      const id = toValue(params.documentId);
      if (!id) throw new Error('Missing document id');
      const res = await deepSignAPI.value.documentsBranding.getBrandings(id, {
        signal
      });

      //TODO @daniel.henkiel missing api definition - Wrong Swagger api response definition see OrganizationBrandingApiResponse;
      const data = res?.data as OrganizationBrandingApiResponse | undefined;
      const branding =
        data?.items?.find((item) => item.channel === 'deepsign') ?? null;
      return branding;
    },
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });

  return query;
}
